export function ChartAvg({ ...rest }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M129.688 230.664C136.156 230.664 141.406 235.906 141.406 242.383V353.125H71.0938V242.383C71.0938 235.906 76.3438 230.664 82.8125 230.664H129.688Z"
        fill="#98A2B3"
      />
      <path
        d="M223.438 160.352C229.906 160.352 235.156 165.594 235.156 172.07V353.125H164.844V172.07C164.844 165.594 170.094 160.352 176.562 160.352H223.438Z"
        fill="#98A2B3"
      />
      <path
        d="M317.188 230.664C323.656 230.664 328.906 235.906 328.906 242.383V353.125H258.594V242.383C258.594 235.906 263.844 230.664 270.312 230.664H317.188Z"
        fill="#98A2B3"
      />
      <path
        d="M400 388.281C400 394.75 394.75 400 388.281 400H11.7188C5.25 400 0 394.75 0 388.281V11.7188C0 5.25 5.25 0 11.7188 0C18.1875 0 23.4375 5.25 23.4375 11.7188V152.539H119.969L190.531 55.7891C194.906 49.4375 205.094 49.4375 209.469 55.7891L280.031 152.539H359.992L347.641 140.188C343.07 135.609 343.07 128.195 347.641 123.617C352.219 119.039 359.641 119.039 364.219 123.617L396.57 155.969C401.039 160.281 401.117 168.039 396.68 172.414C396.617 172.492 396.539 172.562 396.469 172.641L363.336 204.992C361.055 207.219 358.102 208.328 355.148 208.328C352.102 208.328 349.062 207.141 346.766 204.789C342.242 200.164 342.328 192.742 346.961 188.219L359.508 175.977H274.07C270.328 175.977 266.805 174.188 264.602 171.156L200 82.5781L135.398 171.156C133.195 174.188 129.672 175.977 125.93 175.977H23.4375V376.562H388.281C394.75 376.562 400 381.813 400 388.281Z"
        fill="#98A2B3"
      />
    </svg>
  );
}
